import { useTranslation } from 'react-i18next';

import type { Brand } from '~/types/user';

import { useDeleteBrand } from '~/api/user';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  brand: Brand;
  onClose: () => void;
};

export const ConfirmDeleteBrandDialog = ({ brand, onClose }: Props) => {
  const mutation = useDeleteBrand(brand.id);

  const { t } = useTranslation(['common', 'settings']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('settings:profile.brands.delete.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('settings:profile.brands.delete.description', { brand: brand.companyName })}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Trash"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => {
                onClose();
                toast.success({ description: t('settings:alerts.brands.successDeleted') });
              },
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('common:actions.delete')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
